import { hasDirectDescendant } from '../utils/html';

export class Loader {

  /**
   * @param  {Dom}    loaderTarget     target to cover with the loader
   * @param  {String} message          text to display on loading
   * @param  {Bool}   fullscreen       if intended to cover the whole screen
   */
  constructor(loaderTarget, message, fullscreen, theme, deferred) {
    this.loaderTarget = loaderTarget;
    this.message = message;
    this.fullscreen = fullscreen;
    this.theme = theme;
    this.isShowing = false;
    this.isDeferred = deferred;
    this.MILLISECONDS_SECONDS_RATIO = 1000;

    if (!this.isEverythingOk()) {
      return;
    }
    // Initialize loader
    this.init();
  }

  init() {
    if (!this.isDeferred) {
      this.createLoader();
    }
  }

  start() {
    this.createLoader();
  }

  stop() {
    this.destroy();
  }

  createLoader() {
    // Create the various bits of the overlay
    this.loaderOverlay = document.createElement('div');
    this.loaderOverlay.classList.add('loader-overlay');

    if (this.theme !== 'dark') {
      this.loaderOverlay.classList.add(`loader-overlay--${ this.theme }`);
    }

    if (this.fullscreen) {
      this.loaderOverlay.classList.add('loader-fullscreen');
    }


    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('loader-wrapper');
    this.loader = document.createElement('div');
    this.loader.classList.add('loader');
    this.loaderText = document.createElement('p');

    if (Array.isArray(this.message)) {
      // Message is an array - handle progress wording
      for (const wording of this.message) {
        if (wording.hasOwnProperty('changeAt') && wording.hasOwnProperty('text')) {
          if (Number.isInteger(wording.changeAt) && wording.text !== '') {
            setTimeout(() => this.setText(wording.text), wording.changeAt * this.MILLISECONDS_SECONDS_RATIO);
          }
        }
      }
    } else {
      // Set static message
      this.setText(this.message);
    }

    // Create the structure
    this.wrapper.appendChild(this.loader);
    this.wrapper.appendChild(this.loaderText);
    this.loaderOverlay.appendChild(this.wrapper);
    // Add to dom if not already there.
    if (!hasDirectDescendant(this.loaderTarget, this.loaderOverlay)) {
      this.isShowing = true;
      this.loaderTarget.appendChild(this.loaderOverlay);
    }
  }

  setText(message) {
    this.loaderText.innerHTML = message;
  }

  destroy() {
    if (this.isShowing) {
      this.isShowing = false;
      this.loaderTarget.removeChild(this.loaderOverlay);
    }
  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.loaderTarget) {
      console.warn('CommonUI - Loader - No element found to target');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */
}

/**
 * creates a new loader instance
 * @param  {Object} config
 */
export default function initModal(config = {}) {
  const {
    selector = '.js-loader',
    message = 'Loading...',
    fullscreen = true,
    theme = 'dark',
    deferred = false } = config;
  let loader = null;
  if (typeof selector === 'string') {
    loader = new Loader(
      document.querySelector(selector),
      message,
      fullscreen,
      theme,
      deferred
    );
  }
  return loader;
}



// WEBPACK FOOTER //
// ./js/components/Loader.js